// When the user scrolls the page, execute myFunction 
window.onscroll = function() {myFunction()};

// Get the navbar
var navbar = $("#site-navigation");

// Get the offset position of the navbar
var sticky = 30;
// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  // if(sticky > 0){
  if (window.pageYOffset >= sticky) {
    navbar.addClass("c-main-navigation--fixed")
  } else {
    navbar.removeClass("c-main-navigation--fixed");
  }
// }
}
/**
* controls behavior of the alert panel
*/
(function (window) {
	var Self = window.mainNav = {}
	var $ = window.jQuery

	Self.$document = $(document)

	Self.$document.ready(function () {
    	init()
  	})

  	// private functions
  	function init () {

  		Self.$mainNav = $('.c-main-navigation');
  		Self.$mobileNav = $('.c-menu--mobile');
  		Self.open = $('.c-menu-icon--open')
  		Self.close = $('.c-menu-icon--close')

  		Self.$mainNav.on('click','.js-menu-toggle',Self.toggleNav);
  	}

  	Self.toggleNav = function () {
  		Self.$mobileNav.slideToggle();
  		Self.open.toggle();
  		Self.close.toggle();
  	}

})(window)